/* GT Coffee theme JS — small, dependency-free. */
(function () {
  'use strict';

  /* ---------- Mobile menu ---------- */
  document.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
    var panel = document.querySelector('[data-mobile-menu]');
    if (!panel) return;
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      panel.hidden = open;
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') {
        btn.setAttribute('aria-expanded', 'false');
        panel.hidden = true;
        btn.focus();
      }
    });
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var input = step.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    var delta = Number(step.getAttribute('data-qty-step'));
    var min = Number(input.min || 1);
    var next = Math.max(min, (Number(input.value) || min) + delta);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product form: variant selection ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (root) {
    var json = root.querySelector('[data-product-json]');
    if (!json) return;
    var product = JSON.parse(json.textContent);
    var idInput = root.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-price]');
    var buyBtn = root.querySelector('[data-add-to-cart]');
    var buyText = root.querySelector('[data-add-to-cart-text]');
    var optionInputs = root.querySelectorAll('[data-option-input]');
    var money = function (cents) {
      var fmt = root.getAttribute('data-money-format') || '${{amount}}';
      var amount = (cents / 100).toFixed(2);
      return fmt.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
    };

    function selectedOptions() {
      var opts = [];
      product.options.forEach(function (_, i) {
        var checked = root.querySelector('[data-option-input][data-option-index="' + i + '"]:checked, select[data-option-index="' + i + '"]');
        opts.push(checked ? checked.value : null);
      });
      return opts;
    }

    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function update() {
      var variant = findVariant(selectedOptions());
      if (!variant) {
        if (buyBtn) { buyBtn.disabled = true; }
        if (buyText) { buyText.textContent = buyBtn.getAttribute('data-text-unavailable') || 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      // net weight only applies to bags, not K-Cups
      var weightEl = root.querySelector('[data-weight]');
      if (weightEl) {
        var t = (variant.title || '').toLowerCase();
        weightEl.hidden = t.indexOf('k-cup') > -1 || t.indexOf('kcup') > -1 || t === '18.50';
      }
      if (buyBtn) {
        var comingSoon = buyBtn.getAttribute('data-coming-soon') === 'true';
        buyBtn.disabled = !variant.available || comingSoon;
        if (buyText) {
          buyText.textContent = comingSoon
            ? buyBtn.getAttribute('data-text-coming-soon')
            : variant.available
              ? buyBtn.getAttribute('data-text-add')
              : buyBtn.getAttribute('data-text-sold-out');
        }
      }
      // keep the URL in sync so refresh/share keeps the variant
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }
    }

    optionInputs.forEach(function (el) { el.addEventListener('change', update); });
    root.querySelectorAll('select[data-option-index]').forEach(function (el) { el.addEventListener('change', update); });
  });

  /* ---------- Cart: auto-submit quantity changes ---------- */
  document.querySelectorAll('[data-cart-form]').forEach(function (form) {
    var t;
    form.addEventListener('change', function (e) {
      if (!e.target.matches('input[type="number"]')) return;
      clearTimeout(t);
      t = setTimeout(function () { form.submit(); }, 350);
    });
  });
})();
